export enum UmbrellaOrganizationsInvitationsTableAccessor {
  Actions = 'actions',
  Email = 'email',
  InvitationDate = 'invitation-date',
  Invitations = 'invitations',
}
